/** How each sponsor's description is displayed on its card. */
export const SponsorDescriptionDisplay = {
  Hidden: 'hidden',
  Static: 'static',
  Expandable: 'expandable',
} as const;
export type SponsorDescriptionDisplay = (typeof SponsorDescriptionDisplay)[keyof typeof SponsorDescriptionDisplay];

export type SponsorsGridFormData = {
  title?: string;
  showImage: boolean;
  showName: boolean;
  /**
   * @deprecated Superseded by descriptionDisplay; still read as a fallback so
   * configs saved before the option existed keep rendering the same way.
   */
  showDescription?: boolean;
  descriptionDisplay?: SponsorDescriptionDisplay;
  /** Badge chips (per-sponsor text + colour) are shown unless turned off. */
  showBadges?: boolean;
  showAllSponsors: boolean;
  sponsorIds?: string[];
  columns?: number;
};
